import Link from 'next/link';
import { Audit } from 'lib/types';
import { User } from 'lib/types/users';
import { AUDIT_ACTIONS } from 'lib/constants';

interface Props {
  user: User;
  audit: Audit;
}

export const AuditUserAction = ({ user, audit }: Props) => {
  const getActionVerb = (action: string) => {
    switch (action) {
    case AUDIT_ACTIONS.create:
      return 'added';
    case AUDIT_ACTIONS.update:
      return 'updated';
    case AUDIT_ACTIONS.delete:
      return 'removed';
    default:
      return 'added';
    }
  };

  return (
    <div className="flex justify-between">
      <div>
        <Link href={`/${user.username}`} className="hover:underline">

          {user.name}

        </Link>
        <span className="font-semibold">
          {' '}
          {getActionVerb(audit.action)}
        </span>
      </div>
      <div className="text-sm">
        {new Date(audit.createdAt).toLocaleString()}
      </div>
    </div>
  );
};
